import getStore from '../store';
import { updateUnreadReplies } from '../selectors/getUnreadReplies';
import type RowNotificationPayload from 'owa-service/lib/contract/RowNotificationPayload';

export default function unreadNotificationHandler(notification: RowNotificationPayload) {
    if (notification.EventType === 'RowModified') {
        const conversationId = notification?.Conversation?.ConversationId;
        const store = getStore().unreadReplies;

        if (conversationId && store.has(conversationId.Id)) {
            updateUnreadReplies(conversationId);
        }
    }
}
